module.exports = __webpack_public_path__ + "img/inge-v9-char-1.451e7555.png";